import { render, staticRenderFns } from "./view_routing_zone.vue?vue&type=template&id=4371b381&lang=html"
import script from "./view_routing_zone.vue?vue&type=script&lang=js"
export * from "./view_routing_zone.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports